import React from "react";
import stylesLess from "./index.module.less";

export default function FormItem({ title, errMsg, hint = null, children, style }) {
  return (
    <div className={`${stylesLess.main}`} style={style}>
      {title && <div className="iTitle">{title}</div>}
      {children && <div className="iBody">{children}</div>}
      {hint ? <div className="iHint">{hint}</div> : null}
      <div className="iErrMsg">{errMsg || ""}</div>
    </div>
  );
}
